
    module.exports = {
      render: function(){with(this){return _c('div',{attrs:{"id":"video-player-wrapper"}},[_c('video',{staticClass:"video-js",class:error_class,attrs:{"controls":"","id":"video-player","playsinline":"","preload":"auto"}},[_c('source',{attrs:{"src":src,"type":"video/mp4"}})])])}},
      staticRenderFns: []
    };
  